// src/hooks/useInvoiceTracking.js
import { useState } from 'react';
import { getInvoiceTracking } from '../services/shipmentService';

const useInvoiceTracking = () => {
    const [status, setStatus] = useState('idle'); // idle | loading | done | error
    const [error, setError] = useState('');
    const [data, setData] = useState({});

    const fetchInvoiceTracking = async (code) => {
        setStatus('loading');
        setError('');

        try {
            const response = await getInvoiceTracking(code);

            if (response?.status !== 'Error') {
                setData(response?.data ?? response);
                setStatus('done');
            } else {
                setStatus('error');
                setError(response?.message || 'Something went wrong');
            }
        } catch (err) {
            setStatus('error');
            setError(err?.message || 'Something went wrong');
        }
    };

    const resetStatus = () => {
        setStatus('idle');
        setError('');
    };

    return {
        fetchInvoiceTracking,
        data,
        status,
        error,
        resetStatus
    };
};

export default useInvoiceTracking;